import { render } from "./performancetraining.vue?vue&type=template&id=454f419e"
import script from "./performancetraining.vue?vue&type=script&lang=js"
export * from "./performancetraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__